const _temp0 = require("url:../images/logos/canmore.png");

const _temp1 = require("url:../images/logos/coral-gables-monthly.png");

const _temp2 = require("url:../images/logos/coral-gables.png");

const _temp3 = require("url:../images/logos/gava.svg");

const _temp4 = require("url:../images/logos/gloucester-longbeach.png");

const _temp5 = require("url:../images/logos/gloucester.png");

const _temp6 = require("url:../images/logos/melbourne.svg");

const _temp7 = require("url:../images/logos/pittsburgh.svg");

const _temp8 = require("url:../images/logos/sherbrooke.png");

module.exports = {
  "canmore":   {
    "png": _temp0
  },
  "coral-gables-monthly":   {
    "png": _temp1
  },
  "coral-gables":   {
    "png": _temp2
  },
  "gava":   {
    "svg": _temp3
  },
  "gloucester-longbeach":   {
    "png": _temp4
  },
  "gloucester":   {
    "png": _temp5
  },
  "melbourne":   {
    "svg": _temp6
  },
  "pittsburgh":   {
    "svg": _temp7
  },
  "sherbrooke":   {
    "png": _temp8
  }
}